module.exports = __webpack_public_path__ + "img/all-zones-inactive.00dfb077.svg";